export enum MediaQuery {
    Medium = 'only screen and (min-width: 737px)',
    Large = 'only screen and (min-width: 1121px)',
    FullScreenChatWidget = 'only screen and (max-width: 736px), only screen and (max-width: 850px) and (max-height: 450px)',
}
